import { Divider, Typography } from "@material-ui/core"
import { Font } from "components/shopFeatures/wizard/constants"
import styled from "styled-components"

const StyledModelBox = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 10px 20px;
  gap: 30px;

  background: ${(p) => p.theme.colors.lightGrey};
  border-radius: 3px;
  margin-bottom: 30px;
`

const StyledModelDataContainerBottom = styled.div`
  display: flex;
  flex-direction: column;
`

const StyledModelDetail = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 42px;
`

const DetailText = styled.p`
  font-family: ${Font.MazdaType};
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 140%;

  text-align: center;

  color: ${(p) => p.theme.colors.black};
  ${(p) => p.theme.breakpoints.up("md")} {
    font-size: 16px;
    font-weight: 400;
    line-height: 22.4px;
  }
`

const DetailTextHeader = styled.p`
  font-family: OENaPro;
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  color: ${(p) => p.theme.colors.black};

  ${(p) => p.theme.breakpoints.up("md")} {
    font-size: 12px;
    font-weight: 300;
    line-height: 15.6px;
  }
`

const StyledTitle = styled(Typography).attrs({ variant: "h3" })`
  font-family: OENaPro;
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 140%;
  color: #101010;
  margin-bottom: 20px;
`

const StyledModelDetailPadding = styled.div`
  padding: 0px 10px;
`
type Props = {
  data: Item[]
}

type Item = {
  withShekel: boolean
  value: number
  label: string
}

function LoanDetails({ data }: Props) {
  return (
    <>
      <StyledTitle tabIndex={0}>סיכום מסלול המימון</StyledTitle>
      <StyledModelBox>
        <StyledModelDataContainerBottom>
          <StyledModelDetailPadding>
            {data.map((item, index) => {
              return (
                <div key={index.toString()}>
                  <StyledModelDetail>
                    <DetailTextHeader>{item.label}</DetailTextHeader>
                    <DetailText>
                      {item.withShekel
                        ? `₪${item?.value?.toLocaleString()}`
                        : `${item?.value?.toString()} חודשים `}
                    </DetailText>
                  </StyledModelDetail>
                  {index !== data.length - 1 ? (
                    <Divider
                      style={{
                        width: "100%",
                        backgroundColor: "#E7E7E7",
                        height: "1px",
                      }}
                    />
                  ) : null}
                </div>
              )
            })}
          </StyledModelDetailPadding>
        </StyledModelDataContainerBottom>
      </StyledModelBox>
    </>
  )
}

export default LoanDetails
